import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_FILTER_VALUE } from "../const";

const initialState = {
  country: DEFAULT_FILTER_VALUE,
  region: DEFAULT_FILTER_VALUE,
  operator: DEFAULT_FILTER_VALUE,
  savedParksOnly: false,
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    updateCountryFilter(state, action) {
      state.country = action.payload;
      state.region = initialState.region;
    },
    updateRegionFilter(state, action) {
      state.region = action.payload;
    },
    updateOperatorFilter(state, action) {
      state.operator = action.payload;
    },
    toggleSavedParksOnlyFilter(state) {
      state.savedParksOnly = !state.savedParksOnly;
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const {
  updateCountryFilter,
  updateOperatorFilter,
  updateRegionFilter,
  toggleSavedParksOnlyFilter,
  resetFilters,
} = filtersSlice.actions;

export const filtersReducer = filtersSlice.reducer;

export const countryFilterSelector = (state) => state.filters.country;
export const regionFilterSelector = (state) => state.filters.region;
export const operatorFilterSelector = (state) => state.filters.operator;
export const savedParksOnlyFilterSelector = (state) => state.filters.savedParksOnly;

export const areAnyFiltersOnSelector = (state) => {
  const hasCountryFilter = countryFilterSelector(state) !== DEFAULT_FILTER_VALUE;
  const hasRegionFilter = regionFilterSelector(state) !== DEFAULT_FILTER_VALUE;
  const hasOperatorFilter = operatorFilterSelector(state) !== DEFAULT_FILTER_VALUE;
  const hasSavedParksFilter = savedParksOnlyFilterSelector(state);

  return hasCountryFilter || hasRegionFilter || hasOperatorFilter || hasSavedParksFilter;
};
